import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
// import { HttpStatus } from '@core/classes/http-status.class';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, RouterModule } from "@angular/router";

import { SettingsWorkflowsService } from '@app/services/settings/sworkflows.service';
import { WorkflowsService } from '@app/services/settings/workflows.service';
import { AppService } from '@app/services/app/app.service';

import { Workflow } from '@core/objects/workflow';

import { TitleService } from '@core/services/title.service';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';


@Component({
    selector: 'settings-workflows-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsWorkflowsMainComponent implements OnInit, OnDestroy{
    private readonly ACCESS = 'access_setting_workflows_access';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    public workflows: Array<Workflow>
	public showForm:boolean = false;
	public access:boolean = true;
    public status: number = 0;
    public readyList: boolean = true;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        }
    ];


	public menu: Array<ThreeDotsMenuItem> = [{
		title: "Add a new workflow",
		key: "add-workflow",
		icon: "add",
		order: 1
	}];

    protected workflowsListSubscriptor: Subscription;
    protected sessionSubscriptor: Subscription;
    protected workflowsInitializedSubscriptor: Subscription;

	constructor(public workflowsSrv: WorkflowsService, 
        public sworkflowsSrv: SettingsWorkflowsService, 
        public app: AppService, 
        private title: TitleService, 
        private router: Router){}

	ngOnInit(){
        this.title.set("Workflows - System settings");
        this.sessionSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            if (this.access){
                this.load();
            }
        });
        

        this.workflowsListSubscriptor = this.sworkflowsSrv.selectWorkflows().subscribe((workflows: Array<Workflow>) => {
            this.workflows = workflows;
            this.status = this.STATUS_DONE;
        });

        this.workflowsInitializedSubscriptor = this.sworkflowsSrv.selectInitialized().subscribe((initialized: any) => {
            this.readyList = initialized.list;
        });
	}

    ngOnDestroy(): void {
        this.sessionSubscriptor.unsubscribe();
        this.workflowsListSubscriptor.unsubscribe();
        this.workflowsInitializedSubscriptor.unsubscribe();
    }

    onSaved(event){
        this.showForm = false;
        this.load();
    }

    // onColorChange(color: string ,versionStatus: Status){
    //     this.updateColor(versionStatus,color);
    // }

	protected load(){
        // load workflows list in store
        this.sworkflowsSrv.loadWorkflows();
	}

    onSelect(workflow: Workflow) {
        if(!workflow.active  || !this.readyList)
            return;

        this.router.navigate(['/settings/workflows/', workflow.id]);
    }

    deactivate(workflow: Workflow) {
        this.updateActive(workflow, false);
        this.workflowsSrv.deactivateWorkflow$(workflow.id).subscribe({
            next: (empty: any) => {
                this.load();
            },
            error: (err) => {
                this.updateActive(workflow, true); // reset property in the list
                console.debug(" deactivate: errroorrrr ",err);
                this.load();
            }
            
        });
    }

    activate(workflow: Workflow) {
        this.updateActive(workflow, true);
        this.workflowsSrv.activateWorkflow$(workflow.id).subscribe({
            next: (empty: any) => {
                this.load();
            },
            error: (err) => {
                this.updateActive(workflow, false); // reset property in the list
                console.debug("activate: errroorrrr ",err);
                this.load();
            }
            
        });
    }

    updateActive(workflow: Workflow, active: boolean) {
        this.workflows = this.workflows.map((wf: Workflow) => ({
            ...wf,
            active: wf.id === workflow.id ? active : wf.active
          }));
    }

	onMenuClick(key: string) {
        switch(key) {
            case "add-workflow":
                this.showForm = !this.showForm;
                break;
        }
    }
}
